import { IconButton, Tooltip } from '@material-ui/core';
import React from 'react';
import { jsPDF } from "jspdf";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

import autoTable from 'jspdf-autotable'; // eslint-disable-line

const PDFDialog = ({ columns, rows, filename, context, title }) => {

	const pdfDownload = e => {
		e.preventDefault()
		let doc = new jsPDF();
		let head = [columns.filter(c => !c.noprint).map(c => c.label)];
		let body = rows.displayData.map(row => {
			let res = []
			row.data.forEach(item => {
				if (!item) {
					res.push('')
				} else if (typeof item !== 'string') {
					res.push(item.props.title)
				} else {
					res.push(item);
				}
			});
			return res;
		});
		setTimeout(() => {
			doc.autoTable({
				head: [[{ content: title, styles: { halign: 'center', fillColor: '#ffffff', textColor: '#000000' } }]],
				body: [],
				styles: {
					fontSize: 14,
				}
			});
			if (context) {
				doc.autoTable({
					head: context.head,
					body: context.body,
					styles: {
						fontSize: 7
					}
				});
			}
			doc.autoTable({
				head: head,
				body: body,
				styles: {
					fontSize: 7
				}
			});
			doc.save(filename + '.pdf')
		}, 500);
	}


	return (
		< >
			<Tooltip title="PDF export">
				<IconButton onClick={pdfDownload}>
					<PictureAsPdfIcon />
					{/* <GetAppIcon /> */}
					{/* <SVGIcon /> */}
				</IconButton>
			</Tooltip>
		</ >
	)
}

PDFDialog.propTypes = {
}

export default PDFDialog
